import { MESApiService } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { SAW_TABLET_ASSET_NAME } from "../sawTabletConfig";

interface SawTabletAsset {
	AssetId: number;
	AssetName: string;
}

export const getSawTabletAsset = async (): Promise<SawTabletAsset> => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2("[MES].[GetAssets]", []);
	if (!resp.ok) {
		throw new Error(resp.message || "Unable to load the saw line.");
	}

	const rows = get(resp, "data.tables[0].rows", []) as SawTabletAsset[];
	const matches = rows.filter(
		(asset) => asset.AssetName === SAW_TABLET_ASSET_NAME,
	);
	if (matches.length !== 1 || !Number.isInteger(matches[0].AssetId)) {
		throw new Error(`${SAW_TABLET_ASSET_NAME} must identify one active line.`);
	}

	return matches[0];
};
